import React from 'react'

function About() {
    return (
        <>
            {/* <div
                className="w-full h-80 bg-cover bg-center flex items-center justify-center"
                style={{
                    backgroundImage: `url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjWmiqweNJs456ZNquPcFecIqR8Z4iPS80KQ&s)`,
                }}
            >
                <h2 className="text-center text-white font-semibold text-4xl px-6 py-2 rounded-lg bg-black/40">
                    ABOUT US
                </h2>
            </div> */}
            <div className="text-center  pt-20">
                <h2 className="text-4xl font-bold text-gray-800">About Us</h2>
                <p className="text-gray-600 mt-2 max-w-2xl mx-auto text-xl">
                    Here are the text to know about Trav Chap
                </p>
            </div>
            <div className=" py-20">
                <p className=" p-5">Our passion is travelling !!!</p>
                <p className=" p-5">TravChap is more than a travel agency—it’s your trusted companion in exploring the world. Founded on the belief that travel should be as personal as it is inspiring, we design journeys that match your style, passions, and pace. Whether it’s a quick city escape, a luxury getaway, or an offbeat adventure, TravChap turns travel dreams into reality Since 2020.</p>
                <p className=" p-5">With a team of passionate travel experts and partners across the globe, we ensure every trip is seamless from planning to return. Our services include customized tour packages, flight and hotel bookings, visa assistance, and exclusive travel experiences tailored to individuals, families, and corporate clients.</p>
                <p className=" p-5">At TravChap, we don’t just plan trips—we craft stories, create memories, and connect people to places in meaningful ways. Wherever your wanderlust takes you, we’ll be there to make the journey unforgettable.</p>
            </div>

        </>
    )
}

export default About
